/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import type { OptionCodeAnts } from '@/types';

/**
 * Garantit que l'identifiant actuellement affecté à la mention a une entrée dans les options
 * du dropdown « Code ANTS ».
 */
const completerOptionsCodeAnts = (
  options: OptionCodeAnts[],
  identifiantCodeAnts: number | string | undefined | null,
  libelle?: string | null,
): OptionCodeAnts[] => {
  if (_.isNil(identifiantCodeAnts) || identifiantCodeAnts === '') {
    return options;
  }

  const identifiant = Number(identifiantCodeAnts);

  if (_.some(options, (option) => option.value === identifiant)) {
    return options;
  }

  return [
    ...options,
    {
      key: identifiant,
      value: identifiant,
      text: libelle || String(identifiant),
    },
  ];
};

export default completerOptionsCodeAnts;
